import { inject, Injectable, signal } from '@angular/core';
import { ISessionStatistics } from '../interfaces/ISessionStatistics';
import { IShowStatistics } from '../interfaces/IShowStatistics';
import { toObservable } from '@angular/core/rxjs-interop';
import { ShowsStore } from '../../../shows/core/stores/ShowsStore';

@Injectable({
  providedIn: 'root',
})
export class StatisticsStore {

  public readonly sessionStatistics = signal<ISessionStatistics>(null);
  public readonly showsStatistics = signal<IShowStatistics[]>(null);

  private readonly _showsStore = inject(ShowsStore);

  public constructor() {
    toObservable(
      this.showsStatistics
    ).subscribe(showsStatistics => {
      if (showsStatistics) {
        this._showsStore.shows.update(shows => {
          shows = shows.map(s => {
            return {
              ...s,
              statistics: showsStatistics.find(ss => ss.showId === s.id) ?? null
            }
          });

          return shows;
        });
      }
    });
  }
}
